// Core
import { ServerRoute, get, IStateOrProvince } from 'core';

export class StatesService {
  public static async getStates(): Promise<IStateOrProvince[]> {
    const route: ServerRoute = ServerRoute.forAction('StatesAndProvinces');
    return await get(route);
  }
}
